import React from 'react';
import Question from './Question';
import UIComponent from 'components/UiComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { Card } from 'react-bootstrap';

export default class QuestionGroup extends React.Component {
    constructor(props) {
        super(props);
    }

    _sanitizeGroupDesc(value) {
        let trimmedValue = value.trimLeft();
        if (trimmedValue.startsWith('<br>')) trimmedValue = trimmedValue.replace('<br>','');
        if (trimmedValue.startsWith('<br/>')) trimmedValue = trimmedValue.replace('<br/>', '');
        if (trimmedValue.startsWith('<br />')) trimmedValue = trimmedValue.replace('<br />', '');
        
        trimmedValue = trimmedValue.trim();
        if (trimmedValue == "&nbsp;") trimmedValue = "";
        
        return trimmedValue;
    }

    render() {
        return (
            <UIComponent 
                component="accordion"
                activeIcon={ <FontAwesomeIcon icon={faChevronDown} size={"1x"} /> }
                collapsedIcon={<FontAwesomeIcon icon={faChevronRight} size={"1x"} />}
                activeEventKeys={this.props.questionGroupKeysArr}
            >
                <UIComponent
                    component="accordion-group"
                    eventKey={this.props.questionGroup.GROUP_DESC_SHORT}                    
                >
                   
                    {this._sanitizeGroupDesc(this.props.questionGroup.GROUP_DESC) ?
                        <UIComponent 
                            component = "accordion-header"
                        >
                            <span className="group-desc" dangerouslySetInnerHTML={{ __html: this._sanitizeGroupDesc(this.props.questionGroup.GROUP_DESC) }}></span> 
                        </UIComponent>
                        : null
                    }

                    
                    <UIComponent
                        component ="accordion-body"
                        eventKey={this.props.questionGroup.GROUP_DESC_SHORT}                    
                    >
                        <Card className={!this._sanitizeGroupDesc(this.props.questionGroup.GROUP_DESC) ? "no-group-description" : null}>
                            <Card.Body>
                                {this.props.questionGroup.QUESTIONS.map((question, key) => {
                                    return <Question key={key} question={question} />
                                })}
                            </Card.Body>
                        </Card>
                    </UIComponent>
                </UIComponent>
            </UIComponent>

        )
    }
}